import type { RouteRecordRaw } from 'vue-router';
import cleepoRoutes from '@/modules/cleepo/routes/cleepo.routes';
import flokeeRoutes from '@/modules/flokee/routes/flokee.routes';
import {
  BUSINESS_UNITS,
  BusinessUnitKey,
  getBusinessUnitConfig,
  type BusinessUnitConfig,
} from '@/modules/bu/registry.base';

export { BUSINESS_UNITS, BusinessUnitKey, getBusinessUnitConfig, type BusinessUnitConfig };

// Routes are centralized here so adding a BU is a single registry + routes change,
// while avoiding circular imports in shared utils/middlewares.
export const BUSINESS_UNIT_ROUTES: Record<BusinessUnitKey, RouteRecordRaw[]> = {
  [BusinessUnitKey.Flokee]: flokeeRoutes,
  [BusinessUnitKey.Cleepo]: cleepoRoutes,
};

export const getBusinessUnitRoutes = (key_value: BusinessUnitKey) =>
  BUSINESS_UNIT_ROUTES[key_value] ?? [];
